import React from 'react'

export const DesktopTrendingPageLoader = () => {
    return (
        <div className="p-4 space-y-4 w-full mx-auto">
            <div className="h-14 w-full bg-[#0D2436] rounded-md animate-pulse-opacity"></div>
        </div>
    )
}
